import type { TFunction } from 'i18next';

const CONTACT_FIELD_KEY: Record<string, string> = {
  name: 'contacts.activity_field.name',
  email: 'contacts.activity_field.email',
  phone: 'contacts.activity_field.phone',
  external_id: 'contacts.activity_field.external_id',
  time_zone: 'contacts.activity_field.time_zone',
  country_code: 'contacts.activity_field.country_code',
  residence_state: 'contacts.activity_field.residence_state',
  contact_preferences: 'contacts.activity_field.contact_preferences',
  deceased: 'contacts.activity_field.deceased',
};

export const CUSTOM_FIELD_PREFIX = 'custom_fields.';

// A custom field shows its own key; the API sends `custom_fields.<key>`.
export const contactFieldLabel = (field: string, t: TFunction): string => {
  if (field.startsWith(CUSTOM_FIELD_PREFIX)) {
    return field.slice(CUSTOM_FIELD_PREFIX.length);
  }
  const key = CONTACT_FIELD_KEY[field];
  return key ? t(key) : field;
};

/** A tracked field's value as one line of text. Empty values read as "N/A". */
export const formatContactFieldValue = (value: unknown, t: TFunction): string => {
  if (value === null || value === undefined || value === '') {
    return t('common.na');
  }
  if (typeof value === 'boolean') {
    return value ? t('common.yes') : t('common.no');
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};
